import React from "react";

interface PriceInputProps {
  label: string;
  name: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

const PriceInput: React.FC<PriceInputProps> = ({
  label,
  name,
  value,
  onChange,
  placeholder,
}) => {
  return (
    <>
      {!!label && (
        <label
          htmlFor={name}
          className="block mb-2 text-grey text-[16px] manrope capitalize"
        >
          <div className="">{label}</div>
        </label>
      )}
      <input
        name={name}
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder || ""}
        className="p-3 mb-3 text-[16px] bg-white w-full border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
      />
    </>
  );
};

export default PriceInput;
